import { useState, useEffect } from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../ui/card';
import { Button } from '../ui/button';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../ui/table';
import { toast } from 'sonner';
import { api } from '../../utils/api';
import { Trash2 } from 'lucide-react';

const TrustedDevices = () => {
  const [devices, setDevices] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadDevices();
  }, []);

  const loadDevices = async () => {
    setLoading(true);
    try {
      const response = await api.getAllTrustedDevices();
      setDevices(response.devices);
    } catch (error) {
      toast.error('Failed to load devices');
    } finally {
      setLoading(false);
    }
  };

  const handleRemove = async (deviceId) => {
    if (!window.confirm('Remove this trusted device?')) return;

    try {
      await api.removeTrustedDeviceAdmin(deviceId);
      toast.success('Device removed');
      loadDevices();
    } catch (error) {
      toast.error(error.message);
    }
  };

  const formatDate = (isoString) => {
    const date = new Date(isoString);
    return date.toLocaleString();
  };

  return (
    <div className="space-y-6 animate-fade-in">
      <div>
        <h2 className="text-2xl font-bold text-slate-900" data-testid="trusted-devices-title">Trusted Devices</h2>
        <p className="text-slate-600">Manage trusted devices for all users</p>
      </div>

      <Card>
        <CardHeader>
          <CardTitle>All Trusted Devices</CardTitle>
          <CardDescription>View and remove trusted devices</CardDescription>
        </CardHeader>
        <CardContent>
          {loading ? (
            <div className="text-center py-8">Loading devices...</div>
          ) : devices.length === 0 ? (
            <div className="text-center py-8 text-slate-500">No trusted devices</div>
          ) : (
            <div className="overflow-x-auto">
              <Table data-testid="trusted-devices-table">
                <TableHeader>
                  <TableRow>
                    <TableHead>User</TableHead>
                    <TableHead>Email</TableHead>
                    <TableHead>Device Info</TableHead>
                    <TableHead>Added</TableHead>
                    <TableHead>Actions</TableHead>
                  </TableRow>
                </TableHeader>
                <TableBody>
                  {devices.map((device) => (
                    <TableRow key={device.id} data-testid={`device-row-${device.id}`}>
                      <TableCell className="font-medium">{device.user_name}</TableCell>
                      <TableCell>{device.user_email}</TableCell>
                      <TableCell className="text-sm">{device.device_info}</TableCell>
                      <TableCell className="text-sm">{formatDate(device.added_at)}</TableCell>
                      <TableCell>
                        <Button
                          size="sm"
                          variant="destructive"
                          onClick={() => handleRemove(device.id)}
                          data-testid={`remove-device-${device.id}`}
                        >
                          <Trash2 className="w-4 h-4" />
                        </Button>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  );
};

export default TrustedDevices;